import { takeLatest, call, put, all } from 'redux-saga/effects';
import { searchInformation } from '../_services/search.services';
import {
	fetchConfirmSellFund, 
	fetchBuyFundInfo, 
	fetchSellFundInfo,
	fetchSwitchFundInfo,
	fetchCheckedSwitchableFund,
	fetchSendQuestionBackToConfirm,
	fetchBuyableFund,
	fetchSellableFund,
	fetchConfirmSwitchFund
} from '../_services/order-request.services';
import {
	checkedFundAbleToOrderSuccess,
	checkedFundAbleToOrderFailure,
	confirmOrderFundSuccess,
	confirmOrderFundFailure,
	updateFundInfo,
	updateFundInfo2,
	clearSearchFundInfo,
	clearSearchFundInfo2
} from '../_actions/order-request.actions';
import { orderRequestConstants } from '../_constants/order-request.constants';
import { store } from '../redux/store';
import { tranformErrorResponses } from '../_utils/service.utils';

export function* fetchBuyFundInfoAsync({ payload }) {
	try {
		let result = yield call(fetchBuyFundInfo, payload);
		result.data.fund.fundId = payload.fundId;
		result.data.fund.color = payload.color;
		result.data.fund.riskLevel = payload.fund.riskLevel || result.data.fund.riskLevel;
		result.data.fund.categoryName = payload.categoryName;
		result.data.fund.categoryCode = payload.fund.categoryCode;
		yield put(updateFundInfo(result.data));
	} catch (error) {
		yield put(clearSearchFundInfo());
	}
}

export function* fetchCheckedBuyableFundAsync({ payload }) {
	try {
		const result = yield call(fetchBuyableFund, payload);
		yield put(checkedFundAbleToOrderSuccess(result.data));
	} catch (error) {
		yield put(checkedFundAbleToOrderFailure(tranformErrorResponses(error)));
	}
}

export function* fetchCheckedSellableFundAsync({ payload }) {
	try {
		const result = yield call(fetchSellableFund, payload);
		yield put(checkedFundAbleToOrderSuccess(result.data));
	} catch (error) {
		yield put(checkedFundAbleToOrderFailure(tranformErrorResponses(error)));
	}
}

export function* fetchCheckedSwitchableFundAsync({ payload }) {
	try {
		const result = yield call(fetchCheckedSwitchableFund, payload);
		yield put(checkedFundAbleToOrderSuccess(result.data));
	} catch (error) {
		yield put(checkedFundAbleToOrderFailure(tranformErrorResponses(error)));
	}
}

export function* fetchConfirmOrderFundAsync({ payload }) {
	try {
		const state = store.getState();
		const activeTab = state.orderRequest.activeTab;
		const urlAPI = activeTab === 'Buy'
			? fetchSendQuestionBackToConfirm
			:	activeTab === 'Sell'
				? fetchConfirmSellFund
				:	activeTab === 'Switch'
					? fetchConfirmSwitchFund
					: null

		const result = yield call(urlAPI, payload);
		yield put(confirmOrderFundSuccess(result.data));
	} catch (error) {
		yield put(confirmOrderFundFailure(tranformErrorResponses(error)));
	}
}

export function* fetchSellFundInfoAsync({ payload }) {
	try {
		const result = yield call(fetchSellFundInfo, payload);

		const mapData = {
			...result.data,
			fund: {
				...result.data.fund,
				accountType: payload.accountType,
				fundId: payload.fundId,
				color: payload.color,
				categoryCode: payload.fund?.categoryCode
			}
		}
		yield put(updateFundInfo(mapData));
	} catch (error) {
		yield put(clearSearchFundInfo());
	}
}

export function* fetchSwitchFundInfoAsync({ payload }) {
	try {
		const tempPayload = { 
			...payload, 
			toFundId: payload.toFund?.fundId, 
			toFundCode: payload.toFund?.fundCode 
		};
		
		let result = yield call(fetchSwitchFundInfo, tempPayload);
		result.data = { 
			...result.data,
			fund: {
				...result.data.fund,
				color: payload.color,
				fundId: payload.toFund?.fundId,
				categoryCode: payload.toFund?.categoryCode
			}
		}

		yield put(updateFundInfo2(result.data));
	} catch (error) {
		yield put(clearSearchFundInfo2());
	}
}

export function* fetchBuyFundInfoStart() {
	yield takeLatest(orderRequestConstants.FETCH_BUY_FUND_INFO_START, fetchBuyFundInfoAsync);
}

export function* fetchCheckedBuyableFundStart() {
	yield takeLatest(orderRequestConstants.CHECKED_BUYABLE_FUND_START, fetchCheckedBuyableFundAsync);
}

export function* fetchCheckedSellableFundStart() {
	yield takeLatest(orderRequestConstants.CHECKED_SELLABLE_FUND_START, fetchCheckedSellableFundAsync);
}

export function* fetchCheckedSwitchableFundStart() {
	yield takeLatest(orderRequestConstants.CHECKED_SWITCHABLE_FUND_START, fetchCheckedSwitchableFundAsync);
}

export function* fetchSellFundInfoStart() {
	yield takeLatest(orderRequestConstants.FETCH_SELL_FUND_INFO_START, fetchSellFundInfoAsync);
}

export function* fetchSwitchFundInfoStart() {
	yield takeLatest(orderRequestConstants.FETCH_SWITCH_FUND_INFO_START, fetchSwitchFundInfoAsync);
}

export function* fetchConfirmOrderFundStart() {
	yield takeLatest(orderRequestConstants.CONFIRM_ORDER_FUND_START, fetchConfirmOrderFundAsync);
}

export function* orderRequestSagas() {
	yield all([
		call(fetchBuyFundInfoStart),
		call(fetchCheckedBuyableFundStart),
		call(fetchCheckedSellableFundStart),
		call(fetchCheckedSwitchableFundStart),
		call(fetchSellFundInfoStart),
		call(fetchSwitchFundInfoStart),
		call(fetchConfirmOrderFundStart)
	]);
}
